import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';

export const StrategyName = styled.div`
  background: #000;
  font-family: Gramatika;
  font-weight: bold;
  color: #fff;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 58px;
  display: grid;
  grid-template-columns: 1fr 32px;
  padding: 0 20px 0 24px;
  grid-gap: 8px;

  span {
    text-align: right;
  }

  @media (max-width: ${breakpoints.mobileLG}px) {
    width: 100%;

    span {
      text-align: left;
    }
  }
`;
